import styled from 'styled-components';

export const Th = styled.th`
  padding-top: 10px;
  vertical-align: middle;
  background: #4b286d;
  color: #fff;
  & * { color: #fff !important; }
`;

export const Td = styled.td`
  border: 1px solid #e3e3e3;
  vertical-align: middle;
  text-align: ${props => props.textAlign || 'left'};
  font-weight: ${props => (props.bold ? 'bold' : 'normal')};
`;